import envConfig from '../config/environments';

const config = envConfig;

const integrationsLinks = {
	sites: `${config.sitesUrl}/sites/jwt?token=`,
	chamados: `${config.chamadosUrl}/jwt?token=`,
};

export default integrationsLinks;
